export const TEXTS = {
  INVOICE_REQUEST_BUTTON_TEXT: 'Запросить счет',
  INVOICE_REQUEST_BUTTON_DISABLED_TEXT: 'Запрос отправлен',
};
